import React, { useEffect, useState, useReducer } from 'react';
import { withRouter } from "react-router-dom";
import {Button, Grid, TextField, Typography} from '@material-ui/core';
import SaveIcon from "@material-ui/icons/Grade";
import {NotificationManager} from "react-notifications";
import { client } from "../config/apollo";
import Header from "../components/Header";
import {CHEF_REVIEW, USER_REVIEW} from "../graphql/queries/user";
import {BOOKING_BY_TOKEN} from "../graphql/queries/bookings";
import {SUBMIT} from "../graphql/mutations/review"
import { GET_BOOKING_USER_REVIEW } from '../graphql/queries/reviews';
import {primaryColor, webFont} from "../config/theme";
import Fab from "@material-ui/core/Fab";

const initRating = [1, 2, 3, 4, 5];

const ReviewBooking = (props) => {
  const [state, setState] = useReducer((oldProps, newProps) => ({ ...oldProps, ...newProps }), {
    tags: [],
    queryParams: [],
    isChef: false,
    userId: null,
    chefId: null,
    token: null,
    name: '',
    invalidToken: false,
    starReview: 0,
    message: '',
    booking: null,
    selectedReviewTag: [],
    reviewExists: false,
  });

  useEffect(() => {
    if (props.location) {
      if (props.location.search) {
        const search = props.location.search;
        if (search.indexOf('?') > -1) {
          const searchQuery = search.split('?');
          if (searchQuery.length > 1) {
            const searchArr = searchQuery[1].split('&');
            setState({ queryParams: searchArr });
            setState({ invalidToken: false });
          } // end-if searchQuery length
          else setState({ invalidToken: true });
        } // end-if search.indexOf
        else setState({ invalidToken: true });
      } // end-if props.location.search
      else setState({ invalidToken: true });
    } // end-if props.location
    else setState({ invalidToken: true });
  }, []);

  useEffect(() => {
    if (state.queryParams.length === 4) {
      setState({ invalidToken: false });
      setState({
        isChef: state.queryParams[0].split('=')[1] === 'true',
        token: state.queryParams[1].split('=')[1],
        userId: state.queryParams[2].split('=')[1],
        chefId: state.queryParams[3].split('=')[1],
      });
    } else setState({ invalidToken: true });
  }, [state.queryParams]);

  useEffect(() => {
    const { isChef, token, userId, chefId } = state;
    if (userId && chefId && token) {
      setState({ invalidToken: false });
      client.query({
        query: !isChef ? USER_REVIEW : CHEF_REVIEW,
        variables: {
          userId: isChef ? chefId : userId
        }, fetchPolicy: "network-only"
        })
        .then(response => {
          if (isChef) {
            setState({ tags: response.data.reviewTagsForUser })
          } else {
            setState({ tags: response.data.reviewTagsForChef })
          }
        })
        .catch(e => {
          setState({ invalidToken: true });
          console.error('ERROR FETCHING TAG DETAILS: ', e);
        });
    } else setState({ invalidToken: true });
  }, [state.userId]);

  useEffect(() => {
    const { token, userId, chefId } = state;
    if (userId && chefId && token) {
      setState({ invalidToken: false });
      client.query({
          query: BOOKING_BY_TOKEN,
          variables: {
            token
          }, fetchPolicy: "network-only"
        })
        .then(response => {
          if (!response.data.fetchBookingByToken) {
            setState({ invalidToken: true });
          } else {
            setState({ booking: response.data.fetchBookingByToken });
            setState({ invalidToken: false });
          }
        })
        .catch(e => {
          setState({ invalidToken: true });
          console.error('ERROR FETCHING BOOKING DETAILS: ', e);
        });
    } else setState({ invalidToken: true });
  }, [state.token]);

  useEffect(() => {
    const { isChef, booking } = state;
    if (booking) {
      client.query({
          query: GET_BOOKING_USER_REVIEW,
          variables: {
            bookingId: booking.id,
            userId: isChef ? state.chefId : state.userId
          },
        fetchPolicy: "network-only"
        })
        .then(response => {
          if (response) {
            if (response.data) {
              if (response.data.getReviewByBookingIdForUser) {
                setState({ reviewExists: true });
              } else setState({ name: isChef ? booking.userName : booking.chefName });
            } // end-if response.data
            else setState({ name: isChef ? booking.userName : booking.chefName });
          } // end-if response
          else setState({ name: isChef ? booking.userName : booking.chefName });
        })
        .catch(err => {
          console.error('ERR FETCHING Review: ', err);
          setState({ name: isChef ? booking.userName : booking.chefName });
        });
    }
  }, [state.booking]);

  const handleStarReviewClick = review =>{
    let starReview=review;
    setState({starReview});
  }

  const handleReviewClick = review =>{
    let {selectedReviewTag}= state;
    let index = selectedReviewTag.indexOf(review);
    if(index == -1){
      selectedReviewTag.push(review);
    }else{
      selectedReviewTag.splice(index, 1);
    }
    setState({selectedReviewTag});
  }

  const handleMessageChange = e =>{
    let message=e.target.value;
    setState({message});
  }

  const submitReview = () => {
    const { submitReview,userId,chefId, isChef } = state;
    let {starReview,selectedReviewTag,message,booking} = state;
    if(starReview) {
      let payload = {
        reviewer: isChef ? booking.chefId : booking.userId,
        reviewerName: isChef ? booking.chefName : booking.userName,
        reviewType: isChef ? 'USER' : 'CHEF',
        reviewee: isChef ? booking.userId : booking.chefId,
        rating: starReview,
        body: message,
        tags: selectedReviewTag,
        bookingId: booking.id
      }

      client.mutate({
        mutation: SUBMIT,
        variables: {
          review: payload
        }
      })
        .then(res => {
          NotificationManager.info("Review submitted");
          setTimeout(() => {
            props.history.replace('/')
          });
        })
        .catch(err => {
          console.log(JSON.parse(JSON.stringify(err)));
          let errorObj = JSON.parse(JSON.stringify(err));
          if (errorObj.graphQLErrors) {
            errorObj.graphQLErrors.map(error => {
              NotificationManager.error(error.message, "Booking");
            });
          }
        });
    } else {
      NotificationManager.error("Review has not been given");
    }
  }

  let starReviews = initRating.map(review => (
    <div className="tag-button-wrapper">
      <Button
        variant={state.starReview == review ? "contained" : "outlined"}
        color={"primary"}
        aria-label="Add"
        className={state.starReview == review ? 'rating-icon' :  'rating-icon'}
        onClick={() => handleStarReviewClick(review)}
      >
        <SaveIcon htmlColor={state.starReview == review ? '#fff' : primaryColor} />
        <span style={{ color: state.starReview == review ? '#fff' : primaryColor }}>{review}</span>
      </Button>
    </div>));

  const displayTags = state.tags.map(review => {
    return (
      <div className="review-tag-button-wrapper">
        <button
          aria-label="Add"
          style={!!review && state.selectedReviewTag.indexOf(review) == -1 ? styles.selectedReviewOutlined :  styles.selectedReview}
          onClick={() => handleReviewClick(review)}
        >
          {review}
        </button>
      </div>
    );
  });

  return (
    <div className={"review-container-wrapper"}>
      <Header history={props.history} location={props.location} />
      {state.invalidToken ?
        <div className="review-invalid-token">
          Invalid / Expired token.<br />No worries, you can always login and review from your booking card.
        </div> :  state.reviewExists ? (
          <div className="review-exists-token">
            Thank you for your review.
          </div>
        ) : (
          <>
            <div className={"review-wrapper"}>
              <h1>{state.isChef ? 'Patron' : 'Crafter'} rating &amp; review</h1>
              <p>How did you find the experience with {state.name}</p>
            </div>

            <div className="tag-reviews-wrapper">
              <div className="tag-reviews-container">
                {starReviews}
              </div>
            </div>

            <div className="review-title-container">
              <Typography
                style={{
                  ...styles.setFont,
                  fontSize: 20,
                  fontWeight: 'normal',
                  marginBottom: 15,
                  marginTop: 30
                }}
              >
                Review
              </Typography>
            </div>

            <div className="review-tags-container">
              {displayTags}
            </div>

            <div
              style={{
                padding: '0px 20px 20px 0px',
                opacity: 0.62,
                borderRadius: 2,
                borderWidth: 1,
                borderColor: "#979797"
              }}
            >
              <TextField
                fullWidth
                id="outlined-with-placeholder"
                multiline="true"
                rows="3"
                placeholder="Let them know how it went ..."
                margin="normal"
                variant="outlined"
                onChange={(e) => handleMessageChange(e)}
              />
            </div>

            <Grid container>
              <Grid item xs={6}>
                <Fab
                  variant="extended"
                  color={primaryColor}
                  aria-label="Add"
                  style={{...styles.submitReview,textAlign:'center'}}
                  onClick={() => submitReview()}
                >
                  Submit
                </Fab>
              </Grid>
            </Grid>
          </>
        )}

    </div>
  );
};

export default withRouter(ReviewBooking);

const styles = {
  setFont: {
    fontFamily: webFont
  },
  setColor: {
    backgroundColor: primaryColor
  },
  button: {
    margin: 10,
  },
  leftIcon: {
    marginRight: 10,
  },
  rightIcon: {
    marginLeft: 10,
  },
  iconSmall: {
    fontSize: 20,
  },
  ratingIcon :{
    borderRadius: 32,
    width:56,
    height:32,
    color: 'white',
    fontFamily: webFont,
    textTransform: "none",
    margin:5,
    fontSize:14,
    borderImage: 'none'
  },
  submitReview :{
    borderRadius: 32,
    backgroundColor: primaryColor,
    height:32,
    border: "none",
    color: "white",
    fontFamily: webFont,
    textTransform: "none",
    margin: '5px 5px 5px 0px',
    fontSize: 16,
    padding: '20px 40px'
  },
  selectedReview :{
    borderRadius: 40,
    backgroundColor: primaryColor,
    height:32,
    color: 'white',
    fontFamily: webFont,
    textTransform: "none",
    margin:5,
    fontSize:16,
    border:'none',
    paddingRight:10,
    paddingLeft:10,

  },
  selectedReviewOutlined :{
    borderRadius: 40,
    backgroundColor: 'white',
    height:32,
    color: primaryColor,
    fontFamily: webFont,
    textTransform: "none",
    margin:5,
    fontSize:16,
    paddingRight:10,
    paddingLeft:10,
    borderColor:primaryColor

  }

};
